module.exports = __webpack_public_path__ + "img/JLTP_fraction_N1N2N3.637b56f7.svg";